<template>
  <SubContent @back="$router.go(-1)">
    <template v-slot:nav_left> 球员人才输送详细信息 </template>
    <template v-slot:nav_right v-if="talentSendInfo.talentSendStatus === 'audit' && ['admin','system'].includes(userRole)">
      <div  class="yioks_btn" @click="handleAuditTarget">审核</div>
    </template>
    <div v-if="!isLoading" class="scroll_wrap">
      <vue-scroll>
        <div class="itemWrap" v-if="sendAuditLogList.length>0">
          <div class="titleWrap">
            <div class="title">
              <v-icon
                class="logo"
                name="regular/clock"
                scale="1.5"
              ></v-icon>
              <p>人才输送审核过程</p>
            </div>
            <div class="title">
              <p>当前状态：
                <span style="color:#f88594" v-if="talentSendInfo.talentSendStatus === 'refused'">
                  {{talentSendInfo.talentSendStatus | translate}}
                </span>
                <span style="color:#4cd964" v-if="talentSendInfo.talentSendStatus === 'pass'">
                  {{talentSendInfo.talentSendStatus | translate}}
                </span>
                <span style="color:#FF9900" v-if="talentSendInfo.talentSendStatus === 'audit'">
                  {{talentSendInfo.talentSendStatus | translate}}
                </span>
              </p>
            </div>
          </div>
          <div class="timeline">
            <div
              class="timeline-item"
              v-for="(audit, i) in sendAuditLogList"
              :key="audit.id"
            >
              <div class="item_tail" v-show="i !== sendAuditLogList.length - 1"></div>
              <div class="item_node" v-if="audit.auditType === 'auditTalentSend'">
                {{ audit.auditStatus | translate }}
              </div>
              <div class="item_node" v-else>
                提交
              </div>
              <div class="item_wrap">
                <div class="timestamp">
                  <span>{{ audit.createdAt | time(true) }}</span>
                  <span class="audit_people" v-if="audit.auditType === 'auditTalentSend'">
                    审核人：{{ audit.userName }}
                  </span>
                  <span class="audit_people" v-else>提交人：{{ audit.userName }}</span>
                </div>
                <div class="item_cont">
                  <p>
                    <span>{{ audit.auditType | transType}}</span>
                    <span v-if="audit.auditType === 'auditTalentSend'">：{{ audit.auditStatus | translate }}</span>
                  </p>
                  <p v-if="audit.auditType === 'auditTalentSend' && audit.auditInfo">
                    理由 ：{{ audit.auditInfo }} </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="itemWrap" style="margin-bottom:5px">
          <div class="titleWrap">
            <div class="title">
              <v-icon
                class="logo"
                name="chart-bar"
                scale="1.6"
              ></v-icon>
              <p>人才输送信息</p>
            </div>
          </div>
        </div>
        <div class="info_item">
          <div class="base_info">
            <div class="info">
              <div class="col">
                <span>姓名：{{talentSendInfo.playerName}}（{{ talentSendInfo.gender}}）</span>
                <span>身份证号 ：{{talentSendInfo.idNumber}}</span>
              </div>
              <div class="col">
                <span>申报机构：{{ talentSendInfo.youthShortName}}</span>
                <span>出生日期：{{talentSendInfo.birthday | time}}</span>
              </div>
              <div class="col">
                <span>注册时长：{{talentSendInfo.trainTimes || '--'}}个月</span>
                <span>输送教练：{{talentSendInfo.coachOutPutName || '--'}}</span>
              </div>

              <fieldset class="vita-form-fieldset" style="border: 1px dashed  white;padding: 10px ; margin: 0 15px 15px;">
                <legend>在本机构的注册信息</legend>
                <div class="col titleAndInfo" v-for="(playerItem, index) in registerListInfos" :key="index">
                  <div class="focus-tips" v-if="playerItem.registerStatus === 'pass' && ['admin','system'].includes(userRole)">
                    <div class="tips-content">通过</div>
                  </div>
                  <div class="focus-tips" v-if="playerItem.registerStatus === 'audit' && ['admin','system'].includes(userRole)">
                    <div class="tips-content" style="background-color:#FF9900">待审核</div>
                  </div>
                  <div style="display:flex">
                    <span class="titleTitleLeft">起止日期：{{playerItem.registerStart | timeMonth}}
                      <template v-if="playerItem.registerEnd"> 至 {{playerItem.registerEnd | timeMonth}}</template>
                      <template v-else> 至今</template>
                    </span>
                    <span class="titleTitleRight" v-if="playerItem.registerEnd">是否转会：{{playerItem.isTransfer || '否'}}
                      <template v-if="playerItem.isTransfer === '是'">  转至 {{playerItem.youthShortName}}</template>
                    </span>
                  </div>
                  <div v-for="(itemFile, ind) in playerItem.fileList" :key="ind" style="display:flex">
                    <p class="titleTitleFile">
                      证明材料{{ind+1}}：<span class="fileCss" @click="lookFile(itemFile.fileUrl)">{{itemFile.fileName}}</span>
                    </p>
                  </div>
                </div>

              </fieldset>

              <fieldset class="vita-form-fieldset" style="border: 1px dashed  white;padding: 10px ; margin: 0 15px 15px;" v-for="(active, activeInd) in activityListAll " :key="activeInd">
                <div v-for="(playerItem, index) in active " :key="index">
                  <legend v-if="index  === 0">{{playerItem.activityTypeEnum | activityTypeEnumFilter}} 输送记录</legend>
                  <div class="col titleAndInfo" >
                    <div class="focus-tips" v-if="playerItem.activityStatus === 'pass' && ['admin','system'].includes(userRole)">
                      <div class="tips-content">通过</div>
                    </div>
                    <div class="focus-tips" v-if="playerItem.activityStatus === 'audit' && ['admin','system'].includes(userRole)">
                      <div class="tips-content" style="background-color:#FF9900">待审核</div>
                    </div>
                    {{index+1}} ：
                    <div style="display:flex">
                    <span class="titleTitleLeft">
                      起止日期：{{playerItem.activityStart | time}}  <template v-if="playerItem.activityEnd">至 {{playerItem.activityEnd | time}}</template>
                    </span>
                      <span class="titleTitleRight">
                      活动名称：{{playerItem.activityName || '--'}}
                    </span>
                    </div>
                    <div>
                    <span class="titleTitleFile">
                      活动地点：{{playerItem.activityAddress || '--'}}
                    </span>
                    </div>
                    <div v-for="(itemFile, ind) in playerItem.fileList" :key="ind" style="display:flex">
                      <p class="titleTitleFile">
                        证明材料{{ind+1}}：<span class="fileCss" @click="lookFile(itemFile.fileUrl)">{{itemFile.fileName}}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </fieldset>
              <!--<fieldset class="vita-form-fieldset" style="border: 1px dashed  white;padding: 10px ; margin: 0 15px 15px;" v-if="NATIONALYOUTHTEAM.length > 0">-->
                <!--<legend>向国奥、国青、国少队（15 岁及以上）输送球员，并参加正式比赛 输送记录</legend>-->
                <!--<div class="col titleAndInfo" v-for="(playerItem, index) in NATIONALYOUTHTEAM " :key="index">-->
                  <!--<div class="focus-tips" v-if="playerItem.activityStatus === 'pass' && ['admin','system'].includes(userRole)">-->
                    <!--<div class="tips-content">通过</div>-->
                  <!--</div>-->
                  <!--<div class="focus-tips" v-if="playerItem.activityStatus === 'audit' && ['admin','system'].includes(userRole)">-->
                    <!--<div class="tips-content" style="background-color:#FF9900">待审核</div>-->
                  <!--</div>-->
                  <!--<div style="display:flex">-->
                    <!--<span class="titleTitleLeft">-->
                      <!--起止日期：{{playerItem.activityStart | time}}  至 {{playerItem.activityEnd | time}}-->
                    <!--</span>-->
                    <!--<span class="titleTitleRight">-->
                      <!--活动名称：{{playerItem.activityName || '&#45;&#45;'}}-->
                    <!--</span>-->
                  <!--</div>-->
                  <!--<div>-->
                    <!--<span class="titleTitleFile">-->
                      <!--活动地点：{{playerItem.activityAddress || '&#45;&#45;'}}-->
                    <!--</span>-->
                  <!--</div>-->
                  <!--<div v-for="(itemFile, ind) in playerItem.fileList" :key="ind" style="display:flex">-->
                    <!--<p class="titleTitleFile">-->
                      <!--证明材料{{ind+1}}：<span class="fileCss" @click="lookFile(itemFile.fileUrl)">{{itemFile.fileName}}</span>-->
                    <!--</p>-->
                  <!--</div>-->
                <!--</div>-->
              <!--</fieldset>-->

              <!--<fieldset class="vita-form-fieldset" style="border: 1px dashed  white;padding: 10px ; margin: 0 15px 15px;"  >-->
                <!--<legend>全运会记录</legend>-->
                <!--<div class="col titleAndInfo" v-for="(playerItem, index) in activityGamesList" :key="index">-->
                  <!--<div class="focus-tips" v-if="playerItem.activityStatus === 'pass' && ['admin','system'].includes(userRole)">-->
                    <!--<div class="tips-content">通过</div>-->
                  <!--</div>-->
                  <!--<div class="focus-tips" v-if="playerItem.activityStatus === 'audit' && ['admin','system'].includes(userRole)">-->
                    <!--<div class="tips-content" style="background-color:#FF9900">待审核</div>-->
                  <!--</div>-->
                  <!--<div style="display:flex">-->
                    <!--<span class="titleTitleLeft">-->
                      <!--起止日期：{{playerItem.activityStart | time}}  至 {{playerItem.activityEnd | time}}-->
                    <!--</span>-->
                    <!--<span class="titleTitleRight">-->
                      <!--活动名称：{{playerItem.activityName || '&#45;&#45;'}}-->
                    <!--</span>-->
                  <!--</div>-->
                  <!--<div>-->
                    <!--<span class="titleTitleFile">-->
                      <!--活动地点：{{playerItem.activityAddress || '&#45;&#45;'}}-->
                    <!--</span>-->
                  <!--</div>-->
                  <!--<div v-for="(itemFile, ind) in playerItem.fileList" :key="ind" style="display:flex">-->
                    <!--<p class="titleTitleFile">-->
                      <!--证明材料{{ind+1}}：<span class="fileCss" @click="lookFile(itemFile.fileUrl)">{{itemFile.fileName}}</span>-->
                    <!--</p>-->
                  <!--</div>-->
                <!--</div>-->
                <!--<yioks-empty v-if="activityGamesList.length===0" />-->
              <!--</fieldset>-->
              <!--<fieldset class="vita-form-fieldset" style="border: 1px dashed  white;padding: 10px ; margin: 0 15px 15px;"  >-->
                <!--<legend>职业俱乐部记录</legend>-->
                <!--<div class="col titleAndInfo" v-for="(playerItem, index) in activityClubList" :key="index">-->
                  <!--<div class="focus-tips" v-if="playerItem.activityStatus === 'pass' && ['admin','system'].includes(userRole)">-->
                    <!--<div class="tips-content">通过</div>-->
                  <!--</div>-->
                  <!--<div class="focus-tips" v-if="playerItem.activityStatus === 'audit' && ['admin','system'].includes(userRole)">-->
                    <!--<div class="tips-content" style="background-color:#FF9900">待审核</div>-->
                  <!--</div>-->
                  <!--<div style="display:flex">-->
                    <!--<span class="titleTitleLeft">-->
                      <!--起止日期：{{playerItem.activityStart | time}}  <template v-if="playerItem.activityEnd">至 {{playerItem.activityEnd | time}}</template>-->
                    <!--</span>-->
                    <!--<span class="titleTitleRight">-->
                      <!--活动名称：{{playerItem.activityName || '&#45;&#45;'}}-->
                    <!--</span>-->
                  <!--</div>-->
                  <!--<div>-->
                    <!--<span class="titleTitleFile">-->
                      <!--活动地点：{{playerItem.activityAddress || '&#45;&#45;'}}-->
                    <!--</span>-->
                  <!--</div>-->
                  <!--<div v-for="(itemFile, ind) in playerItem.fileList" :key="ind" style="display:flex">-->
                    <!--<p class="titleTitleFile">-->
                      <!--证明材料{{ind+1}}：<span class="fileCss" @click="lookFile(itemFile.fileUrl)">{{itemFile.fileName}}</span>-->
                    <!--</p>-->
                  <!--</div>-->
                <!--</div>-->
                <!--<yioks-empty v-if="activityClubList.length===0" />-->
              <!--</fieldset>-->
            </div>
          </div>
        </div>
      </vue-scroll>
    </div>
    <yioks-loading v-if="isLoading"></yioks-loading>
    <template v-if="isShowAudit">
      <record-audit-msg
        :isShow.sync="isShowAudit"
        :talentSendUuid="talentSendUuid"
        @callback="orgAuditCallback"
      >
      </record-audit-msg>
    </template>
  </SubContent>
</template>

<script>
import playerTalentSend from "@/api/playerTalentSend"; // getPlayerInfo获取球员信息
import storage from "@/utils/storage";
import playImg from '@/assets/images/common/playImg.png'
import {activityTypeEnumFilter} from '@/assets/js/yioksFilters'
import "vue-awesome/icons/regular/clock";
import "vue-awesome/icons/chart-bar";
const filterHash = {
  pass: "通过",
  audit: "待审核",
  refused: "驳回",
};
const filterType = {
  auditTalentSend: "审核人才输送信息",
  submitTalentSend: "提交人才输送信息",
};
export default {
  name: "ScoutRate",

  data() {
    return {
      playImg,
      userRole: storage.get("userInfo").userRole,
      uuid: storage.get("userInfo").uuid,
      isLoading: true,
      talentSendInfo: {},
      registerListInfos: [],
      activityCountryList: [],
      activityGamesList: [],
      activityClubList: [],
      sendAuditLogList: [],
      activityListAll:[],
      NATIONALTEAM:[],
      NATIONALYOUTHTEAM:[],
      GAMESTEAM:[],
      CLUBTEAM:[],
      DISTRICTTEAM:[],
      NATIONALTRAIN:[],
      GAMESTRAIN:[],
      POINTTEAM:[],
      CLUBTRAIN:[],
      DISTRICTTRAIN:[],
      activityTypeEnumFilter,
      isUpload: false,
      isEditMode: false,
      downIng: false,
      isShowAudit: false, // 审核
    };
  },

  components: {
    SubContent: () => import("@/components/layout/newSubContent"),
    "record-audit-msg": () => import("@/views/talentSendPlayer/playerTalentSendAudit"),
  },

  computed: {
    talentSendUuid() {
      const uuid = this.$route.query.talent_send_uuid || "";
      return uuid;
    },
  },

  filters: {
    translate(str) {
      return filterHash[str];
    },
    transType(type) {
      return filterType[type];
    },
    activityTypeEnumFilter,
  },

  mounted() {
    this.getInfo();
  },

  methods: {
    // 审核
    handleAuditTarget() {
      this.isShowAudit = true;
    },
    // 审核弹窗回调
    orgAuditCallback(status) {
      if (status) {
        this.getInfo();
      }
    },
    /* 获取球探报告详细信息 */
    getInfo() {
      playerTalentSend.getTalentSendInfo(this.talentSendUuid).then((res) => {
        if(res.code){
          this.$message.error(res.msg);
          return
        }
        this.talentSendInfo = res.talentSend;
        this.registerListInfos = [];
        this.NATIONALTEAM = [];
        this.NATIONALYOUTHTEAM = [];
        this.GAMESTEAM = [];
        this.CLUBTEAM = [];
        this.DISTRICTTEAM = [];
        this.NATIONALTRAIN = [];
        this.GAMESTRAIN = [];
        this.POINTTEAM = [];
        this.CLUBTRAIN = [];
        this.DISTRICTTRAIN = [];
        this.activityListAll = [];
        // 创建映射对象，将activityTypeEnum值映射到对应数组
        const activityTypeMap = {
          'NATIONALTEAM': this.NATIONALTEAM,           // 国家队
          'NATIONALYOUTHTEAM': this.NATIONALYOUTHTEAM, // 国家青年队
          'GAMESTEAM': this.GAMESTEAM,                 // 全运会队伍
          'CLUBTEAM': this.CLUBTEAM,                   // 职业俱乐部队伍
          'DISTRICTTEAM': this.DISTRICTTEAM,           // 区域代表队
          'NATIONALTRAIN': this.NATIONALTRAIN,         // 国家训练营
          'GAMESTRAIN': this.GAMESTRAIN,               // 全运会训练营
          'POINTTEAM': this.POINTTEAM,               // 重点训练营
          'CLUBTRAIN': this.CLUBTRAIN,                 // 俱乐部训练营
          'DISTRICTTRAIN': this.DISTRICTTRAIN          // 区域训练营
        };
        res.registerList.map(item => {
          item.fileList = [];
          res.fileList.find((ite) => {
            if(ite.recordUuid === item.uuid){
              item.fileList.push(ite);
            }
          })
        });
        // 按照注册时间排序
        if (res.registerList && res.registerList.length) this.registerListInfos = res.registerList.sort((pre, next) => {
          return next.registerStart - pre.registerStart;
        });

        res.activityList.map(item => {
          item.fileList = [];
          res.fileList.find((ite) => {
            if(ite.recordUuid === item.uuid){
              item.fileList.push(ite);
            }
          });
          if (activityTypeMap[item.activityTypeEnum]) {
            activityTypeMap[item.activityTypeEnum].push(item);
          }
//          if(item.activityType === '国家队'){
//            this.activityCountryList.push(item);
//          }
//          if(item.activityType === '全运会'){
//            this.activityGamesList.push(item);
//          }
//          if(item.activityType === '职业俱乐部'){
//            this.activityClubList.push(item);
//          }
        });
        Object.keys(activityTypeMap).forEach(key => {
          if(activityTypeMap[key].length > 0){
            // 按照时间排序
            if (activityTypeMap[key] && activityTypeMap[key].length) activityTypeMap[key] = activityTypeMap[key].sort((pre, next) => {
              return next.activityStart - pre.activityStart;
            });
            this.activityListAll.push(activityTypeMap[key])
          }
        });

//        // 按照时间排序
//        if (this.activityCountryList && this.activityCountryList.length) this.activityCountryList = this.activityCountryList.sort((pre, next) => {
//          return next.activityStart - pre.activityStart;
//        });
//        // 按照时间排序
//        if (this.activityGamesList && this.activityGamesList.length) this.activityGamesList = this.activityGamesList.sort((pre, next) => {
//          return next.activityStart - pre.activityStart;
//        });
//        // 按照时间排序
//        if (this.activityClubList && this.activityClubList.length) this.activityClubList = this.activityClubList.sort((pre, next) => {
//          return next.activityStart - pre.activityStart;
//        });
        this.getAuditLogList();
        this.isLoading = false;
      })
      .catch((err) => {
        console.error("异常", err);
      });
    },
    /* 获取球探报告详细信息 */
    getAuditLogList() {
      playerTalentSend.talentSendAuditLogs(this.talentSendUuid).then((res) => {
        if(res.code){
          this.$message.error(res.msg);
          return
        }
        this.sendAuditLogList = res;
      })
      .catch((err) => {
        console.error("异常", err);
      });
    },
    lookFile(fileUrl){
      if (fileUrl) {
        window.open('http://kkfv.yioks.cn/onlinePreview?url='+encodeURIComponent(this.$Base64.encode(fileUrl)));
      }else{
        this.$message.error('无文件');
      }
    }
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable';
.nav-right-btn
  font-size 18px
  padding 10px 15px
  display -webkit-box
  display -ms-flexbox
  display flex
  -webkit-box-align center
  -ms-flex-align center
  align-items center
  cursor pointer
  -webkit-user-select none
  -moz-user-select none
  -ms-user-select none
  user-select none
  margin-right 10px
  border 1px solid #fff
  &:hover
    background-color #4cd964
    border 1px solid #4cd964
.record-dialog
  color #000
  .title-text
    color #000
    font-size 24px
    border-bottom 1px solid #666
    padding-bottom 10px
.time-line-wrapper
  padding 0 15px
  .time-item
    display flex
    justify-content center
    align-items center
    margin-bottom 20px
    position relative
    &:first-child
      .line
        border-left none
    .line
      height 59%
      border-left 2px solid #666
      position absolute
      top -34px
      left 25px
    .item-left
      width 50px
      height 50px
      display flex
      justify-content center
      align-items center
      border-radius 50%
      border 1px solid #666
      text-align center
    .item-right
      font-size 16px
      width 90%
      margin-left 20px
      .time-content
        text-indent 2px
      .item-info
        min-height 62px
        border-radius 5px
        border 1px solid #ccc
        padding 12px
.focus-action-tips
  .tips-title-wrapper
    color #000
    font-size 24px
    padding-bottom 10px
    border-bottom 1px solid #666
  .focus-action-content
    font-size 16px
  .tips-text
    margin-bottom 10px
    display flex
    align-items center
  .footer-btns-wrapper
    width 60%
    margin 0 auto
    display flex
    justify-content space-around
    font-size 16px
.yioks-outline:focus
  outline-color #4cd964 !important
  border-color #4cd964 !important
.scroll_wrap {
  height: 100%;
  padding: 20px 0 10px 20px;
  box-sizing: border-box;
  overflow: hidden;

  .info_item {
    margin: 0 30px 30px 10px;
    .info_title {
      font-size: 20px;
      padding: 10px 0 20px;
      display: flex;
      align-items: center;

      img {
        margin-right: 10px;
        width: 26px;
      }
    }

    .base_info {
      border: 1px solid #FFF;
      display: flex;
      .info {
        flex: 1;
      }

      .col {
        /*border-bottom: 1px solid #FFF;*/
        // border-right 1px solid #FFF
        padding: 16px 15px;
        display: flex;
        justify-content: space-around;

        span {
          display: inline-block;
          width: 100%;
        }
        .titleTitle{
          width:15%
        }
        .titleTitleLeft{
          width:40%
        }
        .titleTitleRight{
          width:60%
        }
        .titleTitleFile{
          width:100%
        }
        .fileCss{
          width:auto
          color:#4cd964
          cursor:pointer
        }

       /* &:last-child {
          border-bottom: 0;
        }*/
      }
      .titleAndInfo{
        border-top:1px dashed #FFF
        display:block
        line-height:28px
        position relative
        .focus-tips{
          position absolute
          top 0
          right 0
          width 100px
          height 100px
          overflow hidden
          .tips-content{
            width 150px
            height 20px
            line-height 20px
            text-align center
            background-color #4cd964
            transform rotate(45deg)
            position absolute
            top 21px
            right -46px
          }
        }
      }
      .playerImg {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        img {
          width: 120px;
          height: 120px;
          /* height 1.2rem */
          border-radius: 50%;
          padding: 10px;
        }

        p {
          text-align: center;
        }
      }
    }
  }
  .item_title{
    display flex
    align-items center
    font-size .2rem
    padding .4rem 0 .2rem
    margin 0 .3rem
    span{
      margin-left .4rem
      font-size .16rem
    }
    img{
      margin-right .1rem
    }
  }
  .trainPlan{
    display flex
    justify-content space-between
    flex-wrap wrap
    /*margin:0 .3rem;*/
    .planDetail{
      border 1px solid white
      width 100%
      .row{
        min-height 49px
        display flex
        align-items center
        border-bottom 1px solid white
        &:last-child{
          border-bottom none
        }
        .col{
          width:50%
          padding 0 10px 0 20px
          height 100%
          line-height 49px
          text-overflow:ellipsis;
          overflow:hidden;
          white-space:nowrap;
          &:first-child{
            border-right 1px solid white
          }
        }
      }
      .rowLine{
        padding:10px 10px 10px 20px
      }
    }
    .mediaDetail{
      background-color rgba(0, 0, 0, 0.7)
      border 1px solid white
      padding 20px
      width 400px
      display flex
      align-items center
      cursor pointer
      margin-bottom 20px
      .p_item{
        margin-bottom 10px
      }
    }
    .img{
      width 170px
      height 100px
      position relative
      .coverImg{
        width 100%
        height 100%
      }
    }
    .intro{
      padding-left 10px
      width:calc(100% - 170px);
      height 100px
      display flex
      flex-direction column
      justify-content space-between
    }
  }
  .itemWrap{
    margin 0 0 30px 0
    width 96%
    .titleWrap{
      margin 0 0 20px 0
      display flex
      justify-content space-between
      font-size 20px
      user-select none
      align-items end
      .title{
        display flex
        align-items center
        .logo{
          margin 0 10px 0 0
          p{
            line-height 20px
          }
          .btn{
            width auto
            cursor pointer
            height 28px
            margin-left 10px
            padding 13px
            display flex
            justify-content center
            align-items center
            background-color $color_suc
            font-size $font_size_medium
            border-radius 5px
          }
        }
      }
    }
  }
    .timeline{
      display block
      padding-left 3px
      .timeline-item{
        position relative
        padding-bottom 20px
        .item_tail{
          position absolute
          top 36px
          bottom 6px
          left 16px
          // height 100%
          border-left 2px solid #cccccc
        }

        .item_node{
          position absolute
          background-color #fff
          color #333
          border 1px solid #fff
          border-radius 50%
          // left -2px
          width 36px
          height @width
          font-size 12px
          display flex
          align-items center
          text-align center
          justify-content center
        }
        .item_wrap{
          position relative
          padding-left 50px
          top -3px
          .timestamp{
            display flex
            // align-items center
            line-height 1
            margin-bottom 5px
            font-size 15px
            .audit_people{
              flex 1
              text-align right
              margin-left 10px
            }
          }
          .item_cont{
            display block
            background-color #fff
            color #333
            padding 5px 10px
            border-radius 4px
            border 1px solid #cccccc
            overflow hidden
            font-size 15px
            box-shadow 0 2px 12px 0 rgba(255, 255, 255, 0.1)
            line-height 26px
          }
        }
      }
    }
}

.trainPlan {
  .planDetail {
    border: 1px solid white;
    width: 100%;
    display: flex;
    margin-bottom: 15px;

    .info {
      padding: 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-right: 1px solid #FFF;

      p {
        padding-top: 10px;
      }

      img {
        width: 80px;
        height: 80px;
        border-radius: 50%;
      }
    }

    .box-wrap {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
    //   justify-content: space-around;
      justify-content: flex-start;
      padding: 10px 5px 0;

      .box {
        width: 90px;
        display: flex;
        margin: 0 10px 10px
        flex-direction: column;
        // border-right 1px solid #FFF
        // border 1px solid #FFF
        // margin-bottom: 10px;

        p {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 40px;
          text-align: center;
        }

        .content {
          border-top: 1px dashed #FFF;
        }

        .indicatorName {
          color: #4cd964;
        }
      }
    }
  }
}

.w240 {
  width: 240px;
}

.w500 {
  width: 500px;
}

.content-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<style lang="stylus">
.page-content {
  .el-steps--simple {
    background-color: rgba(0, 0, 0, 0);
  }

  .el-form-item__label {
    color: #fff;
    font-size: 16px;
  }
}
</style>
